import { render, staticRenderFns } from "./OrganismPins.vue?vue&type=template&id=4b099d2e&scoped=true&"
import script from "./OrganismPins.vue?vue&type=script&lang=js&"
export * from "./OrganismPins.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPins.vue?vue&type=style&index=0&id=4b099d2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b099d2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculePin: require('/app/components/molecules/project/MoleculePin.vue').default})
